import React, { Component, useEffect, useState } from "react";
import Joi from "joi-browser";
import { Modal, Button } from "react-bootstrap";
import Form from "../../../comman/form";
import BprmForm from "../../../comman/BprmForm";
import http from "../../../services/HttpService";
import auth, { getCurrentUser } from "../../../services/authService";
import config from "../../../config.json";
import ToastTemplate from "../../../comman/toastTemplate";
import { v4 as uuidv4 } from "uuid";
import geo from "../../../services/geoService";
import Swal from "sweetalert2";
import SubForm from "../../PortalForms/SubForm";
import countryCodes from "../../../services/countryCodes.json";
import WorkflowElement from "../../../app/components/WorkflowElement";
import { getAppDefaultData, getStartedAppData, loadAppDefaultData, startNewApplication } from "../../../app/store/application";
import { useDispatch, useSelector } from "react-redux";
import { addNewRecruiter, addNewRecruiterUser, filterRecruiterClear, getFilterAllRecruiters, getNewRecruiterId,
   getNewRecruiterUser, getRecruiterBprmForm, loadRecruiterBprmForm, loadRecruitersByFilter, recruiterAdded, recruiterUserAdded, sendMailToRecruiter } from "../../../app/store/recruiter";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import { currentWfTaskReceived, getCurrentWorkflowTask, loadCurrentWorkflowTask } from "../../../app/store/WorkflowEngine";
import { addFormLibrary } from "../../../app/store/forms";
import { checkedSubEmail, checkedSubUsrEmail, checkedSubUsrMobile, checkSubcontractorEmail,
   checkSubcontractorUsrEmail, checkSubcontractorUsrMobile, filterSubcontractorsClear, getCheckSubEmailStatus, 
   getCheckSubUsrEmailStatus, getCheckSubUsrMobileStatus, subcontractorUserRefresh } from "../../../app/store/subcontractor";
import { updateBprmForm } from "../../../app/store/bprmForm";
import _ from "lodash";
import { recruiterPartnersRecevied } from "../../../app/store/partner";

const EditPartner = (props) => {
  const { selectedObj, handleAddEditRecruiter, selectedTab } = props;
  const [wfTask, setWfTask] = useState(null);
  const [appDefaultData, setAppDefaultData] = useState("");
  const [stateData, setStateData] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [updatedStateData2, setUpdatedStateData2] = useState(null);
  const [saveBtnProcessStatus, setSaveBtnProcessStatus] = useState(false);
  const [uuid, setUuid] = useState("");
  const [wfId, setWfId] = useState(config.workflowsIds.recruiter);
  const [reqCount, setReqCount] = useState(0);
  const [newRecruiterAddedStatus, setNewRecruiterAddedStatus] = useState(false);
  const [wfForm, setWfForm] = useState(null);
  const [saveBtnType, setSaveBtnType] = useState("");
  const [dupliEntry, setDupliEntry] = useState("");
  const [addedParterId, setAddedParterId] = useState(0);
  const [addedParterUserId, setAddedParterUserId] = useState(0);

  const appDefaultDataSelector = useSelector(getAppDefaultData);
  const newRecruiterIdSelector = useSelector(getNewRecruiterId)
  const newRecruiterUserSelector = useSelector(getNewRecruiterUser);
  const appStartedDataSelector = useSelector(getStartedAppData);
  const currentWorkflowTaskSelector = useSelector(getCurrentWorkflowTask);
  const checkSubEmailStatusSelector = useSelector(getCheckSubEmailStatus);
  const checkSubUsrEmailStatusSelector = useSelector(getCheckSubUsrEmailStatus);
  const checkSubUsrMobileStatusSelector = useSelector(getCheckSubUsrMobileStatus);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
  //const filterAllRecruiters = useSelector(getFilterAllRecruiters);

  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedTab === "addEditRecruiter")
      dispatch(loadAppDefaultData(1))
  }, []);

  useEffect(() => {
    if (selectedTab === "addEditRecruiter") {
      let appCiid = 0;
      if (selectedObj?.applications?.length > 0) {
        appCiid = selectedObj?.applications[0].ciid;
      }
      setWfTask({ formId: config.formIds.recruiter, ciid: appCiid });
      dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
      setSaveBtnProcessStatus(false)
    }

  }, [selectedObj, selectedTab]);

  // useEffect(() => {
  //   let appCiid = 0;
  //   if (dupliEntry?.applications?.length > 0) {
  //     const allWfTasks = dupliEntry?.applications[0]?.workflowTasks;
  //     if (allWfTasks?.length > 0) {
  //       appCiid = allWfTasks[allWfTasks.length - 1].ciid;
  //     }
  //     setWfTask({ formId: config.formIds.subcontractor, ciid: appCiid });
  //   }
  //   setSaveBtnProcessStatus(false)

  // }, [dupliEntry]);

  // useEffect(() => {
  //   if (filterAllRecruiters.length > 0) {
  //     setDupliEntry(filterAllRecruiters[0])
  //   }

  // }, [filterAllRecruiters])

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    if (appDefaultDataSelector !== "") {
      setAppDefaultData(appDefaultDataSelector);
    }
  }, [appDefaultDataSelector]);



  const handleSubmit = (stData) => {
    const aWorkfinityApp = { ...appDefaultData };
    const appShortName = Object.keys(aWorkfinityApp)[1];
    let aWorkfinityAppEntity = { ...aWorkfinityApp[appShortName] };
    let recruiterenrollment = {};
    const data = {};
    Object.keys(stData).forEach(function (keyValue) {
      const dd = keyValue.split(".");
      if (dd.length > 1) {
        if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
          recruiterenrollment["@" + dd[1]] = stData[keyValue];
        data[dd[1]] = stData[keyValue];
      }
    });

    const guid = uuidv4();
    const jhgf = JSON.parse(updatedStateData);
    const entiyId = jhgf?.HROCCMSAppEntity?.recruiterenrollmentform?.EntityId;

    if (!selectedObj || selectedObj === "") {
      if (addedParterUserId <= 0) {
        recruiterenrollment["EntityId"] = guid;
        data["EntityId"] = guid;
      } else {
        const jhgfss = JSON.parse(updatedStateData2);
        const entiyId2 = jhgfss?.HROCCMSAppEntity?.recruiterenrollmentform?.EntityId;
        recruiterenrollment["EntityId"] = entiyId2;
        data["EntityId"] = entiyId2;
      }
    } else {
      recruiterenrollment["EntityId"] = entiyId;
      data["EntityId"] = entiyId;
    }

    const usrDdtype = "recruiterenrollmentform";
    aWorkfinityAppEntity[usrDdtype] = recruiterenrollment;
    aWorkfinityApp[appShortName] = aWorkfinityAppEntity;

    setStateData(data);
    setUuid(guid)
    setAppDefaultData(aWorkfinityApp);

    if (!selectedObj || selectedObj === "") {
      if (addedParterId <= 0) {
        const partEmail = data["Company_Email"];
        const keyEmail = data["Key_Contact1_Email"];
        const keyMobile = data["Key_Contact1_Mobile"];
        if (partEmail && partEmail !== "") {
          dispatch(checkSubcontractorEmail(partEmail, "Recruiter"));
        } else if (keyEmail && keyEmail !== "") {
          dispatch(checkSubcontractorUsrEmail(keyEmail, "Recruiter"));
        } else if (keyMobile && keyMobile !== "") {
          dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
        } else {
          saveRecruiter(data);
        }
      } else {
        saveRecruiter(data);
      }
    }
    else {
      saveRecruiter(data);
    }
  }

  useEffect(() => {
    const keyEmail = stateData ? stateData["Key_Contact1_Email"] : "";
    const keyMobile = stateData ? stateData["Key_Contact1_Mobile"] : "";
    if (checkSubEmailStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Recruiter Email alreday exist. Do you want Add duplicate Email Address?", "warning");
        if (rs.isConfirmed) {
          if (keyEmail && keyEmail !== "") {
            dispatch(checkSubcontractorUsrEmail(keyEmail, "Recruiter"));
          } else if (keyMobile && keyMobile !== "") {
            dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
          }
          else {
            saveRecruiter(stateData);
          }
        }
        else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubEmailStatusSelector === false) {
      if (keyEmail && keyEmail !== "") {
        dispatch(checkSubcontractorUsrEmail(keyEmail, "Recruiter"));
      } else if (keyMobile && keyMobile !== "") {
        dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
      }
      else {
        saveRecruiter(stateData);
      }
    }
  }, [checkSubEmailStatusSelector]);

  useEffect(() => {
    const keyMobile = stateData ? stateData["Key_Contact1_Mobile"] : "";

    if (checkSubUsrEmailStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Recruiter key contact Email alreday exist. Do you want Add duplicate Email Address?", "warning");
        if (rs.isConfirmed) {
          if (keyMobile && keyMobile !== "") {
            dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"))
          }
          else {
            saveRecruiter(stateData);
          }
        } else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubUsrEmailStatusSelector === false) {
      if (keyMobile && keyMobile !== "") {
        dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
      }
      else {
        saveRecruiter(stateData);
      }
    }
  }, [checkSubUsrEmailStatusSelector]);

  useEffect(() => {
    if (checkSubUsrMobileStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Recruiter key contact Mobile Number alreday exist. Do you want Add duplicate Mobile Number?", "warning");
        if (rs.isConfirmed) {
          saveRecruiter(stateData);
        } else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubUsrMobileStatusSelector === false) {
      saveRecruiter(stateData);
    }
  }, [checkSubUsrMobileStatusSelector]);

  const saveRecruiter = (data) => {
    if (!data) return;

    const fuid =
      selectedObj?.fuid ??
      (addedParterId > 0 ? addedParterId : 0);

    const getValue = (field) => (data[field] || "").trim();

    const contactName = [
      "Key_Contact1_First_Name",
      "Key_Contact1_Middle_Name",
      "Key_Contact1_Last_Name",
    ]
      .map((field) => getValue(field))
      .filter(Boolean)
      .join(" ");

    const partnerObj = {
      fuid,
      label: getValue("Company_Name"),
      state: getValue("Company_State"),
      city: getValue("Company_City"),
      zip: getValue("Company_Zip_Code"),
      partnerType: "Recruiter",
      contactName,
      entryStartNumber: 1,
      entryEndNumber: 100,
      totalEntryRecords: 100,
      email: getValue("Company_Email"),
      accessKey: getValue("Company_Address_Line1"),
      portalUrl: getValue("Company_Address_Line2"),
    };

    dispatch(addNewRecruiter(partnerObj));
  };


  useEffect(() => {
    if (newRecruiterIdSelector > 0) {
      if (newRecruiterIdSelector === -1) {
        getAlert("Warning", "Email already exists", "error");
        setSaveBtnProcessStatus(false);
      }
      else {
        saveRecruiterUser(newRecruiterIdSelector);
        if (addedParterId === 0 && !selectedObj) {
          dispatch(sendMailToRecruiter(newRecruiterIdSelector))
        }
        setAddedParterId(newRecruiterIdSelector);
      }
    }
  }, [newRecruiterIdSelector]);

  const saveRecruiterUser = (partId) => {
    if (!stateData) return;

    const data = { ...stateData };

    // Determine recruiter user ID
    const regId = selectedObj?.id ?? (addedParterUserId > 0 ? addedParterUserId : 0);

    // Helper to safely extract trimmed values
    const get = (field) => (data[field] || "").trim();

    const reg = {
      id: regId,
      first_Name: get("Key_Contact1_First_Name"),
      middle_Name: get("Key_Contact1_Middle_Name"),
      last_Name: get("Key_Contact1_Last_Name"),
      email: get("Key_Contact1_Email"),
      mobile: get("Key_Contact1_Mobile"),

      workflowId: wfId,
      entityId: uuid,

      // Hard-coded security question (might want dynamic later)
      question: "3151",
      answer: "Miami",

      type: "recruiter",

      // Address fields
      address_Line1: get("Company_Address_Line1"),
      address_Line2: get("Company_Address_Line2"),
      us_State: get("Company_State"),
      us_County: get("Company_County"),
      us_City: get("Company_City"),
      zip_Code: get("Company_Zip_Code"),

      title: get("Key_Contact1_Title"),
      isTeamLead: true,
      partnerId: partId,
    };

    const aWorkfinityApp = { ...appDefaultData };

    // Build FormData payload
    const formData = new FormData();
    formData.append("appEntity", JSON.stringify(aWorkfinityApp));
    formData.append("registration", JSON.stringify(reg));

    dispatch(addNewRecruiterUser(formData));
    setSaveBtnProcessStatus(true);
  };


  const updateBprmFormData = async (aWorkfinityApp) => {
    const disValus = _.uniq(["recruiterenrollmentform"]);
    const frmData = new FormData();
    frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
    frmData.append("ciid", wfTask.ciid);
    frmData.append("ddTypes", disValus);
    frmData.append("formId", wfTask.formId);
    frmData.append("performerId", currentUser.id);
    frmData.append("userName", currentUser.name);
    dispatch(updateBprmForm(frmData));
  };

  useEffect(() => {
    if (newRecruiterUserSelector) {
      setSaveBtnProcessStatus(false);
      let regId = 0;
      if (selectedObj?.id) {
        regId = selectedObj?.id;
      } else if (addedParterUserId > 0) {
        regId = addedParterUserId;
      }

      if (newRecruiterUserSelector.performerid === -1) {
        getAlert("Warning", newRecruiterUserSelector.performername, "error");
        setSaveBtnProcessStatus(false);
        handleAddEditRecruiter("exit");
      }
      else {
        if (regId > 0) {
          getAlert("", "Updated Successfully", "success");
          setNewRecruiterAddedStatus(false);

          if (wfTask.ciid > 0)
            updateBprmFormData(appDefaultData);

          if (saveBtnType === "saveAndContinue") {
            //dispatch(filterRecruiterClear([]))
            //dispatch(filterSubcontractorsClear([]))
            dispatch(checkedSubEmail(null))
            dispatch(checkedSubUsrEmail(null))
            dispatch(checkedSubUsrMobile(null))
            handleAddEditRecruiter("exit");
          }
          // else if (saveBtnType === "saveAndExit") {
          //   handleAddEditRecruiter();
          // }
          // else {
          //   handleAddEditRecruiter();
          // }
        } else {
          // var frmBody = new FormData();
          // frmBody.append("id", newRecruiterIdSelector);
          // frmBody.append("name", "");
          // frmBody.append("email", "");
          // frmBody.append("type", "Recruiter");
          getAlert("", "Added Successfully", "success");
          if (saveBtnType === "saveAndContinue") {
            //dispatch(filterRecruiterClear([]))
            //dispatch(filterSubcontractorsClear([]))
            dispatch(checkedSubEmail(null))
            dispatch(checkedSubUsrEmail(null))
            dispatch(checkedSubUsrMobile(null))
            handleAddEditRecruiter("exit");
          }
          //  else {
          //   setTimeout(() => {
          //     dispatch(loadRecruitersByFilter(frmBody));
          //     getAlert("", "Added Successfully", "success");
          //   }, 4000);
          // }
          dispatch(recruiterPartnersRecevied([]))
          //setSaveBtnProcessStatus(true)
          setAddedParterUserId(newRecruiterUserSelector.performerid);
          handleRunApplication(newRecruiterUserSelector);
        }

      }
      dispatch(recruiterAdded(0))
      dispatch(recruiterUserAdded(null))
    }
  }, [newRecruiterUserSelector]);

  const handleRunApplication = async (userObj) => {
    const newApplication = {
      workflowId: userObj.workflowId,
      performerId: parseInt(userObj.performerid),
      applicationId: userObj.applicationId,
    };
    dispatch(startNewApplication(newApplication));
    setNewRecruiterAddedStatus(true);
    if (saveBtnType === "saveAndContinue")
      handleAddEditRecruiter("exit");
  };

  useEffect(() => {
    if (appStartedDataSelector?.ciid > 0) {
      setTimeout(async () => {
        dispatch(loadCurrentWorkflowTask(appStartedDataSelector));
        setReqCount(1);
      }, 3000);
    }
  }, [appStartedDataSelector]);

  useEffect(() => {
    if (currentWorkflowTaskSelector?.formId === null && reqCount <= 2 && newRecruiterAddedStatus) {
      setTimeout(async () => {
        dispatch(loadCurrentWorkflowTask(appStartedDataSelector));
        const rqCount = reqCount + 1;
        setReqCount(rqCount)
      }, 3000);
    }
    else if (currentWorkflowTaskSelector?.wiid > 0 && newRecruiterAddedStatus) {
      // const formsObj = [
      //   {
      //     formId: 47,
      //     formName: "ACH Payment Information",
      //     remarks:
      //       "This information is captured for making Payments to your company by ACH",
      //     formType: "ACH Information",
      //   },
      //   {
      //     formId: 22,
      //     formName: "Insurance Details",
      //     remarks:
      //       "Upload your company's insurance certificate(s) as per the contract requirements",
      //     formType: "Insurance Information",
      //   },
      // ];
      setNewRecruiterAddedStatus(false);
      dispatch(currentWfTaskReceived(""));
      //formsObj.map((item) => addReqFormLibrary(currentWorkflowTaskSelector, item));
      setWfTask(currentWorkflowTaskSelector);
    }
  }, [currentWorkflowTaskSelector]);

  const addReqFormLibrary = async (currentTask, frmObj) => {
    let workflowTask = { ...currentTask };
    workflowTask["ApplicantId"] = workflowTask.performerId;
    workflowTask["performerId"] = currentUser.id;
    const frmData = new FormData();
    frmData.append("workflowTask", JSON.stringify(workflowTask));
    frmData.append("formId", frmObj.formId);
    frmData.append("formName", frmObj.formName);
    frmData.append("remarks", frmObj.remarks);
    frmData.append("id", "");
    frmData.append("formType", frmObj.formType);
    frmData.append("status", "1");
    dispatch(addFormLibrary(frmData));
  };

  useEffect(() => {
    if (selectedObj?.contact1) {
      setUpdatedStateData(selectedObj.contact1.performerData)
    }
    else {
      setUpdatedStateData(null);
    }
  }, [selectedObj]);

  useEffect(() => {
    if (dupliEntry?.contact1) {
      setUpdatedStateData2(dupliEntry.contact1.performerData)
    }
    else {
      setUpdatedStateData2(null);
    }
  }, [dupliEntry]);

  const handleNextTask = (data, btn) => {
    handleSubmit(data);
    if (btn) setSaveBtnType(btn)
  }

  return (
    <div className="col-md-12">
      <div className="row">

        {wfForm && <WorkflowElement
          wfTask={wfTask}
          wfForm={wfForm}
          handleNextTask={handleNextTask}
          viewType={false}
          appSummary={false}
          codeVerified={selectedObj?.contact1?.performerid ? false : true}
          wfTaskType={"form"}
          actionType={"workflow"}
          saveBtnProcessStatus={saveBtnProcessStatus}
          setSaveBtnProcessStatus={setSaveBtnProcessStatus}
          updatedStateData={updatedStateData}
        />
        }
        
      </div>
    </div>
  );
}

export default EditPartner;
